module.exports = __webpack_public_path__ + "static/media/photo139.42388a30.jpg";